export const payload = {
  receiveMutation: 'RECEIVE_BATCHES',
  receivingMutation: 'RECEIVING_BATCHES',
  receiveMetadataMutation: 'RECEIVE_BATCH_METADATA',
  savingMutation: 'SAVING_BATCH',
  incrementMutation: 'INCREMENT_BATCH_COUNT',
  updatingMutation: 'UPDATING_BATCH',
  deleteMutation: 'DELETE_BATCH',
  deletingMutation: 'DELETING_BATCH',
  resetMetaMutation: 'RESET_BATCH_META',
  clearMutation: 'CLEAR_BATCH_STATE',
  moduleName: 'batch',
  endpoint: 'batches',
  defaultModelGetter: 'getDefaultBatch',
  searchableFields: ['name', 'description']
}



// WEBPACK FOOTER //
// ./src/components/RouteComponents/Batches/actionPayload.js